<script setup lang="ts">
import Footer from '~/domains/common/components/Footer.vue'
</script>

<template>
  <slot />
  <Footer />
</template>
